import React, { Component } from 'react'
import Icon from 'components/icon/icon'
import Button from 'components/button/button'
import { connect } from 'react-redux'
import { updateTask } from 'state/actions'

import ValidateResponse from 'components/validations/validate-response'
import withValidateResponse from 'components/validations/withValidateResponse'
import { stringIsEmpty } from 'utils/utils'

import InputStandard from 'components/input/standard'

class ModalTaskName extends Component {
    state = {
        name: ''
    }
    
    UNSAFE_componentWillMount(){
        this.setState({
            name: this.props.data.name
        })
    }

	saveItem = _ => {
		if(this.props.isLoading){
			return 
		}

		if(stringIsEmpty(this.state.name)) {
			this.props.handleError("Please enter a task name")
			return
		}

		const taskObject = {
            ...this.props.data,
            name: this.state.name
		}
        
        this.props.updateTask(taskObject, 'save item from modal task name')

        this.props.closeCallback()
    }
    
    handleChange = e => {
        this.setState({
            name: e.target.value
        })
    }

	render() {
    	setTimeout(_ => { 
    		this.refs.taskName.inputRef.focus()
    	}, 1)

		return(
			<div>
				<div className={'borders'}>
					<InputStandard 
						outlineOnFocus={true} 
						ref="taskName" 
						callback={this.saveItem} 
						value={this.state.name} 
						onChange={this.handleChange} 
						placeholder="E.g 'Mockups', or 'Documents'" 
					/>
				</div>
				<ValidateResponse 
					dismissCallback={this.props.handleDismiss}
					response={this.props.validateResponse} 
				/>
				<Button 
					size={'big'} 
					level={'high'} 
					callback={this.saveItem} 
					label={'Save'} 
					icon={'check'} 
				/>
				<Button 
					size={'big'} 
					level={'low'} 
					callback={this.props.closeCallback} 
					label={'Cancel'}
				 />
			</div>
		);
	}
}

const ModalTaskNameWithValidateResponse = withValidateResponse(ModalTaskName);

export default connect(null, { updateTask })(ModalTaskNameWithValidateResponse);
